module.exports = __webpack_public_path__ + "static/media/fly0030.98f63b51.webp";